import React from "react";
import CardClass from "../../../CardClass";
import Table from "../../../Table";
import PropTypes from "prop-types";
import { withRouter } from 'react-router-dom';
import MainContext from "../../../../Context/MainContext/MainContext";

export default withRouter(class CardAdminBaseUnitTypeList extends CardClass {
    static contextType = MainContext; // For legacy class components

    /**
     * Renders the content of the card.
     */
    renderContent() {
        return (
            <Table
                search={true}
                columns={[
                    { key: "id", name: "ID", type: "number" },
                    { key: "name", name: "Name", type: "string" },
                ]}
                rows={Object.values(this.context.baseUnitTypesIndexed)}
                onClick={(baseUnitType) => {
                    this.props.history.push({
                        pathname: "/admin/baseUnitType/" + baseUnitType.id
                    });
                }}
            />
        );
    }
});